import { IShopifyProductIdSearch } from '@Saral-Influencer-Marketing/saral-utils/src/types';

export type FrequentlyShippedProduct = IShopifyProductIdSearch[];

export interface FrequentlyShippedProductsState {
  frequentlyShippedProducts: FrequentlyShippedProduct[];
  isLoading: boolean;
  error: string | null;
  lastFetched: number | null;
}

export enum FrequentlyShippedProductsActionTypes {
  FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST',
  FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS',
  FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE',
}
